import { ColumnDef, Row } from "@tanstack/react-table";
import { StudentTestResult } from "./types";
import Tag from "@/components/Tag";
import { toFormat } from "@/lib/dateHelpers";

export const buildColumns = (): ColumnDef<StudentTestResult>[] => {
  const columns: ColumnDef<StudentTestResult>[] = [
    {
      accessorKey: "testId",
      header: "Test ID",
      size: 110,
      enableSorting: false,
      cell: ({ row }: { row: Row<StudentTestResult> }) => row.original.testId
    },
    {
      accessorKey: "testName",
      header: "Test Name",
      size: 400,
      enableSorting: false,
      cell: ({ row }: { row: Row<StudentTestResult> }) => row.original.testName,
      meta: {
        headerClassName: "hide-header-in-column"
      }
    },
    {
      accessorKey: "level",
      header: "Level",
      size: 70,
      enableSorting: false,
      cell: ({ row }: { row: Row<StudentTestResult> }) => row.original.level
    },
    {
      accessorKey: "testDate",
      header: "Test Date",
      size: 140,
      enableSorting: false,
      cell: ({ row }: { row: Row<StudentTestResult> }) => toFormat(row.original.testDate)
    },
    {
      accessorKey: "isRetake",
      header: "Is Retake",
      size: 90,
      enableSorting: false,
      cell: ({ row }: { row: Row<StudentTestResult> }) => (row.original.isRetake ? "Yes" : "No")
    },
    {
      accessorKey: "score",
      header: "Score",
      size: 90,
      enableSorting: false,
      cell: ({ row }: { row: Row<StudentTestResult> }) => {
        const { score, maxScore } = row.original;
        return `${score} / ${maxScore}`;
      }
    },
    {
      accessorKey: "passed",
      header: "Status",
      size: 110,
      enableSorting: false,
      cell: ({ row }: { row: Row<StudentTestResult> }) => {
        const passed = row.original.passed;
        return (
          <Tag tagType={passed ? "success" : "error"} tagStyle="strong" size="small">
            {passed ? "Passed" : "Failed"}
          </Tag>
        );
      },
      meta: {
        headerClassName: "hide-header-in-column"
      }
    }
  ];

  return columns;
};

export type StudentTestResultRow = StudentTestResult;
